import { render, staticRenderFns } from "./statusItemV2.vue?vue&type=template&id=f7fb0b34&scoped=true&"
import script from "./statusItemV2.vue?vue&type=script&lang=js&"
export * from "./statusItemV2.vue?vue&type=script&lang=js&"
import style0 from "./statusItemV2.vue?vue&type=style&index=0&id=f7fb0b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fb0b34",
  null
  
)

export default component.exports